<template>
  <div
    class="allOrder"
    :class="{ allOrder_left: orderStyle == 20 && isSupplier == 1 }"
    :style="orderStyle == 20 && isSupplier == 1 ? listHeight_left : listHeight"
  >
    <p class="search" @click="showDatePopup">
      <span>{{ selectData }}</span>
      <span class="icon"><van-icon name="play" /></span>
    </p>
    <van-pull-refresh
      v-model="isLoading"
      @refresh="onRefresh"
      v-if="list.length != 0"
    >
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <van-cell class="lists" v-for="(item, index) in list" :key="index">
          <div>
            <van-row>
              <van-col span="24" class="title">
                <img :src="item.head_pic" />
                {{ item.user_name }}
                <span v-if="(item.status == 20 || item.status == 25)&&(!item.has_sale)">待发货</span>
                <span v-if="item.status == 30&&(!item.has_sale)">已发货</span>
                <span v-if="item.has_sale" class="after_sales">{{item.status == 30?'已':'待'}}发货，用户发起售后</span>
              </van-col>
              <van-col span="24" class="goods_info">
                <span v-if="orderStyle == 20 && isSupplier == 1">
                  <img
                    class="select_icon"
                    v-if="!item.select"
                    @click="selectSingle(item)"
                    src="@/assets/purchaseSupplier/common/no_select.png"
                  />
                  <img
                    class="select_icon"
                    v-if="item.select"
                    @click="selectSingle(item)"
                    src="@/assets/purchaseSupplier/withdraw/selected.png"
                  />
                </span>
                <div @click="detail(item)">
                  <div
                    class="info_box"
                    v-for="(goods, index) in item.order_goods"
                    :key="index"
                  >
                    <div class="left">
                      <img :src="goods.sku_image" @error="nofind()" />
                      <p class="goods_name">{{ goods.goods_name }}</p>
                      <p class="spec">
                        <span v-if="goods.specification_name">规格：</span
                        >{{ goods.specification_name }}
                      </p>
                      <!-- <p>运费￥{{ goods.goods_postage }}</p> -->
                    </div>
                    <div class="right">
                      <p>￥{{ goods.cost_price }}</p>
                      <p>X{{ goods.quantity }}</p>
                    </div>
                  </div>
                  <p class="money">
                    运费：￥{{ item.order_goods[0].goods_postage }}
                  </p>
                  <p class="money price">
                    合计金额：<span>￥{{ item.amount }}</span>
                  </p>
                </div>
              </van-col>
            </van-row>
            <van-row>
              <van-col span="24" class="btns">
                <btn
                  :btntext="'联系买家'"
                  :btnwidth="'8rem'"
                  :height="'3.2rem'"
                  :bgcolor="'#fff'"
                  :borderradius="'1.6rem'"
                  :btncolor="'#333'"
                  :fontsize="'1.2rem'"
                  :btnborder="'solid 0.1rem #ccc'"
                  :btnmargin="'1.1rem 0 0 1.2rem'"
                  @btnClick="contact(item)"
                />
                <btn
                  :btntext="'立即发货'"
                  :btnwidth="'8rem'"
                  :height="'3.2rem'"
                  :bgcolor="'linear-gradient(to right, #fc740c, #f41a3c)'"
                  :borderradius="'1.6rem'"
                  :btncolor="'#fff'"
                  :fontsize="'1.2rem'"
                  :btnmargin="'1.1rem 0 0 1.2rem'"
                  v-if="item.status != 30 && isSupplier == 1"
                  @btnClick="ship(item,'0')"
                />
                 <btn
                  :btntext="'修改物流信息'"
                  :btnwidth="'10rem'"
                  :height="'3.2rem'"
                  :bgcolor="'#fff'"
                  :borderradius="'1.6rem'"
                  :btncolor="'#333'"
                  :fontsize="'1.2rem'"
                  :btnborder="'solid 0.1rem #ccc'"
                  :btnmargin="'1.1rem 0 0 1.2rem'"
                  v-if="item.status == 30 && isSupplier == 1"
                  @btnClick="ship(item,'1')"
                />
                <btn
                  :btntext="'查看物流'"
                  :btnwidth="'8rem'"
                  :height="'3.2rem'"
                  :bgcolor="'linear-gradient(to right, #fc740c, #f41a3c)'"
                  :borderradius="'1.6rem'"
                  :btncolor="'#fff'"
                  :fontsize="'1.2rem'"
                  :btnmargin="'1.1rem 0 0 1.2rem'"
                  v-if="item.status == 30"
                  @btnClick="logistics(item)"
                />
              </van-col>
            </van-row>
          </div>
        </van-cell>
      </van-list>
    </van-pull-refresh>

    <div class="countMsg" v-show="orderStyle == 20 && isSupplier == 1">
      <p class="select">
        <img
          v-show="!allSelect"
          @click="selectAll()"
          src="@/assets/purchaseSupplier/common/no_select.png"
        />
        <img
          v-show="allSelect"
          @click="notSelectAll()"
          src="@/assets/purchaseSupplier/withdraw/selected.png"
        />
        全选
      </p>
      <p class="selectinfo">
        已勾选<span class="selectedNum">{{ slectOrderId.length }}</span
        >条<span class="allNum">共{{ allList }}条</span>
      </p>
      <btn
        class="confirm_btn"
        :btntext="'生成待发货记录'"
        :btnwidth="'16.5rem'"
        :height="'4.4rem'"
        :bgcolor="'linear-gradient(to right, #FC740C, #F41A3C)'"
        :borderradius="'2.2rem'"
        :btncolor="'#fff'"
        :fontsize="'1.6rem'"
        @btnClick="exportOrder"
      />
    </div>
    <van-row class="empty" v-if="list.length == 0 && !hasList">
      <van-col class="emptyMsg" span="24">
        <img src="../../../assets/purchaseSupplier/common/no_info.png" />
        <p class="tip">无内容</p>
      </van-col>
    </van-row>
    <div class="loading" v-if="list.length <= 0 && hasList">
      <img src="../../../assets/accountAgent/common/loading.gif" />
    </div>
    <van-popup v-model="showdate" position="bottom">
      <van-row class="title">
        <van-col span="12" :class="{ active: selectFirst }">
          <p class="decs">开始日期</p>
          <p>{{ startTime }}</p>
          <span></span>
        </van-col>
        <van-col span="12" :class="{ active: !selectFirst }">
          <p class="decs">结束日期</p>
          <p>{{ endTime }}</p>
          <span></span>
        </van-col>
      </van-row>
      <van-datetime-picker
        :formatter="formatter"
        v-model="currentDate"
        type="date"
        :min-date="minDate"
        :item-height="'5.1rem'"
        :visible-item-count="5"
        @change="changeTime($event)"
      />
      <p class="btns">
        <btn
          class="left"
          :btntext="'重置'"
          :btnwidth="'16.6rem'"
          :height="'4.4rem'"
          :bgcolor="'#fff'"
          :borderradius="'0.4rem'"
          :btncolor="'#333'"
          :fontsize="'1.6rem'"
          :btnborder="'solid 0.05rem #ccc'"
          @btnClick="allTime"
        />
        <btn
          :btntext="selectFirst ? '下一步' : '确定'"
          :btnwidth="'16.6rem'"
          :height="'4.4rem'"
          :bgcolor="'linear-gradient(to right, #FC740C, #F41A3C)'"
          :borderradius="'0.4rem'"
          :btncolor="'#fff'"
          :fontsize="'1.6rem'"
          @btnClick="confirm"
        />
      </p>
    </van-popup>
  </div>
</template>
<script>
import btn from "../components/button.vue";
import defaultImg from "@/assets/common/compare.png";
import avatarDefault from "@/assets/common/avatar.png";
export default {
  components: {
    btn,
  },
  props: {
    orderStyle: {
      type: String,
      detault: "20",
    },
    gooodsName: {
      type: String,
      detault: "",
    },
    isSearch: {
      type: String,
      detault: "",
    },
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      isLoading: false,
      page: 1,
      pageSize: 10,
      allList: 11, //默认比第一页数据多1
      listHeight: {
        height:''
          // (document.body.clientHeight - 142) /
          //   (document.body.clientWidth / 375) /
          //   10 +
          // "rem",
      },
      listHeight_left: {
        height:''
          // (document.body.clientHeight - 142 - 65) /
          //   (document.body.clientWidth / 375) /
          //   10 +
          // "rem",
      },
      hasList: true,
      showdate: false,
      selectData: "全部时间",
      startTime: "请选择",
      endTime: "请选择",
      currentDate: new Date(),
      minDate: new Date(2021, 0, 1),
      selectFirst: true,
      allSelect: false,
      slectOrderId: [],
      // storeId: "",
      isSupplier: ""
    };
  },
  mounted(){
    this.$nextTick(()=>{
      let NavH = (document.body.clientWidth / 375) * 10 * 8.8 + 54;
      this.listHeight.height = ( document.body.clientHeight - NavH)/ (document.body.clientWidth / 375)/ 10 + "rem";
      this.listHeight_left.height = ( document.body.clientHeight - NavH - 65)/ (document.body.clientWidth / 375)/ 10 + "rem";
    })
  },
  async created() {
    // this.storeId = this.$route.query.store_id;
    this.isSupplier = this.$route.query.is_supplier;
    if (this.isSearch && this.gooodsName == "") {
      this.hasList = false;
      return;
    }
    this.getInfo();
  },
  watch: {
    gooodsName() {
      this.page = 1;
      this.list = [];
      this.getInfo();
    },
  },
  methods: {
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.page++;
        this.getInfo();

        // 加载状态结束
        this.isLoading = false;
      }, 500);
    },
    onRefresh() {
      this.page = 1;
      this.finished = false;
      this.list = [];
      this.getInfo();
    },
    getInfo() {
      if (this.page == 1) {
        this.allSelect = false;
        this.slectOrderId = [];
      }
      let parm = {
        page: this.page,
        search: this.gooodsName,
        order_status_list: this.orderStyle == 20 ? [20, 25] : [30],
        supplier_member_id: this.$route.query.member_id,
      };
      if (this.selectData != "全部时间") {
        parm = {
          page: this.page,
          search: this.gooodsName,
          order_status_list: this.orderStyle == 20 ? [20, 25] : [30],
          start_time: this.startTime,
          end_time: this.endTime,
          supplier_member_id: this.$route.query.member_id,
        };
      }
      this.$api
        .post("/onorder/member/supplier/order/list", parm)
        .then((res) => {
          this.allList = res.total;
          if (res.total <= 0) {
            this.hasList = false;
          }
          if (res.list.length > 0) {
            for (let i in res.list) {
              res.list[i].select = false;
              this.allSelect = false;
              res.list[i].head_pic = res.list[i].head_pic || avatarDefault;
              this.list.push(res.list[i]);
            }
          }
          this.loading = false;
          if (this.list.length >= this.allList) {
            // 数据全部加载完成
            this.finished = true;
          }
          if (this.isLoading) {
            this.$toast("刷新成功");
            this.isLoading = false;
          }
        })
        .catch((err) => {
          this.hasList = false;
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
        });
    },
    detail(item) {
      let params = {
         id: item.id,
          // store_id: this.storeId,
          is_supplier: this.isSupplier,
          supplier_member_id: item.supplier_member_id,
      }
      this.$router.push({
        path: "/purchaseSupplier/detail",
        query: params
      });
    },
    contact(item) {
      let parm = {
        id: item.member_id,
        name: item.user_name,
        store_id: item.shop_id,
        supplier_member_id: item.supplier_member_id,
      };
      this.params(JSON.stringify(parm), JSON.stringify(parm), "contact");
    },
    ship(item,type) {
      localStorage.setItem( "addressInfo", JSON.stringify(item.delivery_address));
      if(type == '1'){
        localStorage.setItem( "logisticsInfo", JSON.stringify(item.order_logistics));
      }
      this.$router.push({
        path: "/purchaseSupplier/ship",
        query: {
          type: type,
          orderid: item.id,
          goodsid: item.order_goods[0].goods_id,
        },
      });
    },
    logistics(item) {
      localStorage.setItem(
        "delivery_address",
        JSON.stringify(item.delivery_address)
      );
      this.$router.push({
        path: "/purchaseSupplier/logisticsDetail",
        query: {
          com: item.order_logistics[0].post_code,
          nu: item.order_logistics[0].post_no,
          name: item.order_logistics[0].post_name,
          phone: item.delivery_address.consignee_mobile,
        },
      });
    },
    nofind() {
      var img = event.srcElement;
      img.src = defaultImg;
      img.onerror = null; //防止闪图
    },
    showDatePopup() {
      this.startTime = "请选择";
      this.endTime = "请选择";
      this.selectFirst = true;
      this.currentDate = new Date();
      this.changeTime(this.currentDate);

      this.showdate = true;
    },
    formatter(type, value) {
      if (type === "year") {
        return `${value}年`;
      } else if (type === "month") {
        return `${value}月`;
      }
      return value;
    },
    changeTime(value) {
      var year = this.currentDate.getFullYear();
      var month = this.currentDate.getMonth() + 1;
      var day = this.currentDate.getDate();
      if (this.selectFirst) {
        this.startTime =
          year + "-" + (month < 10 ? "0" + month : "" + month) + "-" + day;
      } else {
        this.endTime =
          year + "-" + (month < 10 ? "0" + month : "" + month) + "-" + day;
      }
    },
    confirm() {
      if (this.selectFirst) {
        this.selectFirst = false;
        this.changeTime(this.currentDate);
        return;
      }
      // if (this.startTime == "请选择") {
      //   this.$toast("请选择开始时间");
      //   return;
      // } else if (this.endTime == "请选择") {
      //   this.$toast("请选择结束时间");
      //   return;
      // }
      this.showdate = false;
      this.selectData =
        this.startTime.replace(/-/g, ".") +
        "-" +
        this.endTime.replace(/-/g, ".");
      this.page = 0;
      this.list = [];
      this.onLoad();
    },
    allTime() {
      this.showdate = false;
      this.selectData = "全部时间";
      this.startTime = "请选择";
      this.endTime = "请选择";
      this.page = 0;
      this.list = [];
      this.onLoad();
    },
    selectSingle(item) {
      item.select = !item.select;
      if (item.select) {
        this.slectOrderId.push(item.id);
        if (this.slectOrderId.length == this.list.length) {
          this.allSelect = true;
        }
      } else {
        let index = this.slectOrderId.indexOf(item.id);
        this.slectOrderId.splice(index, 1);
        this.allSelect = false;
      }
    },
    selectAll() {
      this.slectOrderId = [];
      this.allSelect = true;
      this.list.forEach((item) => {
        item.select = true;
        this.slectOrderId.push(item.id);
      });
    },
    notSelectAll() {
      this.allSelect = false;
      this.list.forEach((item) => {
        item.select = false;
      });
      this.slectOrderId = [];
    },
    exportOrder() {
      let parm = "";
      if (this.slectOrderId.length > 0) {
        this.slectOrderId.forEach((item, index) => {
          if (index == 0) {
            parm = item + "";
          } else {
            parm = parm + "," + item;
          }
        });
      } else {
        this.$toast("请至少选择一个订单！");
        return;
      }
      this.$api
        .get("/onorder/index/order/order-download-pdf", { order_ids: parm })
        .then((res) => {
          this.$router.push({
            path: "/purchaseSupplier/result",
            query: {
              type: 6,
              pdfSrc: res.url,
            },
          });
        })
        .catch((err) => {
          this.hasList = false;
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
        });
    },
  },
};
</script>
<style lang="less" scoped>
.allOrder {
  background-color: #f5f6f7;
  min-height: 100%;
  box-sizing: border-box;
  padding: 4.4rem 1.6rem 0;
  position: relative;

  .empty {
    padding-top: 10rem;

    .emptyMsg {
      text-align: center;

      img {
        width: 16rem;
        display: inline-block;
      }

      .tip {
        color: #cccccc;
        font-size: 1.4rem;
        margin-top: 1.7rem;
        height: 2rem;
        line-height: 2rem;
      }
    }
  }
  
  .loading {
    width: 100%;
    /*padding-top: 100px;*/
    text-align: center;

    img {
      width: 35%;
      margin-top: 50%;
    }
  }

  .van-pull-refresh {
    // height: 100%;
    height: calc(100% - 4.4rem);
    // padding-top: 1.2rem;
    box-sizing: border-box;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;

    .lists {
      min-height: 25.6rem;
      border-radius: 0.8rem;
      background: #fff;
      margin-bottom: 1.2rem;
      padding: 0;

      .title {
        color: #333;
        font-size: 1.2rem;
        text-align: left;
        height: 4.5rem;
        line-height: 4.5rem;
        padding: 0 1.6rem 0 1.2rem;
        box-sizing: border-box;
        border-bottom: solid 0.05rem #eee;

        img {
          width: 2rem;
          height: 2rem;
          border-radius: 1rem;
          margin-right: 0.8rem;
          float: left;
          margin-top: 1.2rem;
        }

        span {
          color: #ff4747;
          font-size: 1.2rem;
          float: right;
        }
        .after_sales{
          font-size: 1.4rem;
        }
      }

      .goods_info {
        min-height: 15.4rem;
        font-size: 1.4rem;
        color: #333;
        padding: 1.1rem 1.6rem 1.2rem 1.2rem;
        box-sizing: border-box;
        border-bottom: solid 0.05rem #eee;

        .info_box {
          position: relative;
          min-height: 8rem;

          .left {
            padding: 0 6.5rem 0 9rem;

            img {
              width: 8rem;
              height: 8rem;
              // float: left;
              position: absolute;
              top: 0;
              left: 0;
            }

            p {
              line-height: 1.8rem;
            }

            .goods_name {
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
              white-space: normal;
            }

            .spec {
              color: #999;
              min-height: 2rem;
              margin: 0.6rem 0 0;
            }
          }

          .right {
            float: right;
            position: absolute;
            right: 0;
            top: 0;
            min-width: 6.5rem;
            text-align: right;

            p {
              margin-bottom: 0.4rem;
            }
          }
        }

        .money {
          color: #999;
          line-height: 2rem;
          text-align: right;
          margin-top: 0.7rem;

          span {
            color: #ff4747;
          }
        }

        .price {
          color: #333;
          margin-top: 0.4rem;
        }
      }

      .btns {
        text-align: right;
        padding: 0 1.5rem 1.2rem;
      }
    }
  }

  .van-popup {
    height: 43rem;

    .title {
      height: 8rem;

      .van-col {
        background: #f8f8f8;
        text-align: center;
        height: 8rem;

        p {
          color: #333;
          font-size: 1.4rem;
          line-height: 1.7rem;
        }

        .decs {
          color: #999;
          font-size: 1.2rem;
          margin: 1.8rem 0 0.6rem;
          line-height: 2rem;
        }
      }

      .active {
        background: #fff;

        span {
          display: block;
          width: 100%;
          height: 0.3rem;
          margin-top: 1.6rem;
          background: -webkit-linear-gradient(to right, #fc740c, #f41a3c);
          /* Safari 5.1 - 6.0 */
          background: -o-linear-gradient(to right, #fc740c, #f41a3c);
          /* Opera 11.1 - 12.0 */
          background: -moz-linear-gradient(to right, #fc740c, #f41a3c);
          /* Firefox 3.6 - 15 */
          background: linear-gradient(to right, #fc740c, #f41a3c);
        }
      }
    }

    /deep/.van-picker {
      height: 29rem;
      padding: 1.6rem 0;
      box-sizing: border-box;

      .van-picker__toolbar {
        display: none;
      }
    }

    .btns {
      padding-left: 1.6rem;

      .left {
        margin-right: 1.1rem;
      }
    }
  }

  .search {
    height: 2.1rem;
    line-height: 2.1rem;
    padding: 0 1.6rem;
    color: #2c2c2f;
    font-size: 1.2rem;
    margin: 1.1rem 0;

    span {
      float: left;
      .van-icon {
        margin-left: 0.7rem;
        width: 0.5rem;
        transform: translateY(-3px);
        transform: rotate(90deg);
        -ms-transform: rotate(90deg); /* IE 9 */
        -moz-transform: rotate(90deg); /* Firefox */
        -webkit-transform: rotate(90deg); /* Safari 和 Chrome */
        -o-transform: rotate(90deg);
      }
    }

    .icon {
      margin-top: -0.2rem;
    }
  }

  .countMsg {
    position: absolute;
    bottom: -6.45rem;
    left: 0;
    width: 100%;
    padding: 0.4rem 1.5rem 1.2rem;
    background: #fff;
    box-sizing: border-box;
    height: 6.45rem;

    .select {
      color: #333;
      font-size: 1.4rem;
      margin-top: 1rem;

      img {
        width: 2rem;
        margin-right: 0.8rem;
        vertical-align: middle;
      }
    }

    .selectinfo {
      color: #333;
      font-size: 1.4rem;
      line-height: 2rem;
      margin-top: 0.5rem;

      .selectedNum {
        color: #fb6b10;
      }

      .allNum {
        color: #999;
        font-size: 1rem;
        margin-left: 1rem;
      }
    }

    .confirm_btn {
      position: absolute;
      bottom: 1.2rem;
      right: 1.5rem;
    }
  }
}

.allOrder_left {
  // padding-bottom: 6.45rem;

  .van-pull-refresh {
    .lists {
      .goods_info {
        padding-left: 4.4rem;
        position: relative;

        .select_icon {
          width: 2rem;
          position: absolute;
          top: 4.2rem;
          left: 1.2rem;
        }
      }
    }
  }
}
</style>
<style lang="less" scoped>
.van-dialog {
  border-radius: 0;

  .van-dialog__confirm,
  .van-dialog__cancel {
    height: 5.2rem;
    font-size: 1.6rem;
  }

  .van-dialog__content--isolated {
    min-height: 6.2rem;

    .van-dialog__message {
      padding: 2.1rem 1rem;
      color: #333;
      font-weight: 700;
      font-size: 1.6rem;
    }
  }
}
</style>
